import { library, dom } from "@fortawesome/fontawesome-svg-core";
import * as SolidIcons from "@fortawesome/free-solid-svg-icons";

export default function initIcons()
{
    library.add(SolidIcons.faBars);
    dom.watch();
}
